import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Input from 'components/Input';

import { isRequiredFloatGreaterThan } from 'utilities/validators';

const degreesOfFreedomValidator = isRequiredFloatGreaterThan(0);

class StudentDistributionFieldsComponent extends React.PureComponent {
  static propTypes = {
    onDofChange: PropTypes.func.isRequired
  }

  render () {
    return (
      <Field
        name="dof"
        type="number"
        component={Input}
        label="Degrees of Freedom"
        onChange={this.props.onDofChange}
        validate={degreesOfFreedomValidator}
        wrapperClassName="flex-basis mb-15 relative"
      />
    );
  }
}

export default StudentDistributionFieldsComponent;
